import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

import { downloadDocument2 } from "@/api/rest/services/documentService";
import { DocumentsPreview } from "@/components/household-contents/document/DocumentsPreview.tsx";

import { SelfCheck } from "./selfCheck";

const SelfCheckTip: React.FC<{ selfCheck: SelfCheck }> = ({ selfCheck }) => {
  const { t } = useTranslation();

  return (
    <div className="rounded-md border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm text-emerald-900">
      <p className="m-0 font-semibold">{t("warrantyIntake.selfCheckTitle")}</p>
      <ul className="m-0 list-disc pl-5">
        {selfCheck.steps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ul>
      {selfCheck.documents.length > 0 && (
        <div className="my-1 flex flex-wrap gap-2">
          {selfCheck.documents.map((doc) => (
            <DocumentsPreview
              key={doc.id}
              className="bg-white hover:bg-emerald-100 p-2 rounded text-sm"
              document={doc}
              onSelect={downloadDocument2}
              allowPreview
            >
              <span className="flex items-center gap-1">
                <DocumentTextIcon className="h-4 w-4 flex-shrink-0" />
                <span className="truncate">{doc.fileName}</span>
              </span>
            </DocumentsPreview>
          ))}
        </div>
      )}
      <p className="m-0">{t("warrantyIntake.selfCheckHint")}</p>
    </div>
  );
};

export default SelfCheckTip;
